import { CONTROLS } from './constants.js';

/**
 * Local keyboard input for both players (split keyboard).
 *
 * P1 (AZERTY native):
 *   Move: ZQSD (physical = KeyW KeyA KeyS KeyD)
 *   Weapons: 1 (rock) / 2 hold (paper) / 3 (scissors)
 *
 * P2:
 *   Move: Arrow keys
 *   Weapons: Numpad1 (rock) / Numpad2 hold (paper) / Numpad3 (scissors)
 */
export class InputLocal {
  constructor() {
    this.keys = {};
    this.justPressed = {};
    this._prevKeys = {};

    this._onKeyDown = (e) => {
      // Prevent browser defaults for game keys BUT allow F12 etc
      const code = e.code;
      if (this._isGameKey(code)) e.preventDefault();
      this.keys[code] = true;
    };
    this._onKeyUp = (e) => {
      const code = e.code;
      if (this._isGameKey(code)) e.preventDefault();
      this.keys[code] = false;
    };

    window.addEventListener('keydown', this._onKeyDown);
    window.addEventListener('keyup', this._onKeyUp);
  }

  _isGameKey(code) {
    // Return true for codes used by either player so we prevent default
    // Don't block Digit keys (not used for gameplay anymore)
    return code === 'KeyW' || code === 'KeyA' || code === 'KeyS' || code === 'KeyD' ||
           code === 'KeyX' || code === 'KeyC' || code === 'KeyV' ||
           code === 'KeyF' || code === 'KeyG' ||
           code.startsWith('Arrow') || code.startsWith('Numpad') ||
           code === 'Space';
  }

  update() {
    this.justPressed = {};
    for (const code in this.keys) {
      if (this.keys[code] && !this._prevKeys[code]) {
        this.justPressed[code] = true;
      }
    }
    this._prevKeys = { ...this.keys };
  }

  /**
   * Get actions for a player.
   * @param {0|1} playerId
   */
  getActions(playerId) {
    const c = playerId === 0 ? CONTROLS.p1 : CONTROLS.p2;
    const a = {
      moveX: 0, moveY: 0,
      rock: false, paper: false, paperHold: false, scissors: false, dash: false,
    };

    if (this.keys[c.up])    a.moveY = -1;
    if (this.keys[c.down])  a.moveY = 1;
    if (this.keys[c.left])  a.moveX = -1;
    if (this.keys[c.right]) a.moveX = 1;

    if (this.justPressed[c.rock])     a.rock = true;
    if (this.keys[c.paper])           a.paperHold = true;
    if (this.justPressed[c.paper])    a.paper = true;
    if (this.justPressed[c.scissors]) a.scissors = true;
    if (this.justPressed[c.dash])     a.dash = true;

    return a;
  }

  dispose() {
    window.removeEventListener('keydown', this._onKeyDown);
    window.removeEventListener('keyup', this._onKeyUp);
  }
}
